const FlashMessage = {
    methods: {
        flashSuccess(message) {
            this.$toast.add({
                severity: 'success',
                summary: 'Sukces',
                detail: message,
                life: 3000
            });
        },
        flashWarning(message, title = "warning"){
            this.$toast.add({
                severity: 'warn',
                summary: title,
                detail: message,
                life: 6000
            })
        },
        flashError(message, summary = "Error") {
            this.$toast.add({
                severity: 'error',
                summary: summary,
                detail: message,
                life: 6000
            });
        }
    }
};

export default FlashMessage;
